import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchBoxByModalComponent } from './search-box-by-modal.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { CustomSearchBoxModule } from './search-box/search-box.module';
import { ScreenViewModule } from '../../../../core/directives/screen-view/_screen-view.module';

@NgModule({
  declarations: [SearchBoxByModalComponent],
  imports: [CommonModule, I18nModule, CustomSearchBoxModule, ScreenViewModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchBoxComponent: {
          component: SearchBoxByModalComponent,
        },
      },
    }),
  ],
})
export class SearchBoxByModalModule {}
